"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Area3DStacked = void 0;
const react_1 = __importStar(require("react"));
const victory_1 = require("victory");
const ChartStyles_1 = require("../helpers/ChartStyles");
const StandardChart_1 = __importDefault(require("../helpers/StandardChart"));
function Area3DStacked(props) {
    const { xLabels, fontSize, data, width, height } = props;
    let calcFontSize = Math.max(Math.min(fontSize ? fontSize : Math.ceil(height / 14), 20), 12);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(StandardChart_1.default, Object.assign({}, props, { xLabels: xLabels }),
        react_1.default.createElement(victory_1.VictoryStack, { animate: ChartStyles_1.ChartStyles.anim }, data.map((item, idx) => {
            var _a;
            return (react_1.default.createElement(victory_1.VictoryArea, { labelComponent: react_1.default.createElement(victory_1.VictoryTooltip, { renderInPortal: false, flyoutStyle: {
                        fill: (_a = item[0]) === null || _a === void 0 ? void 0 : _a.color2,
                        strokeWidth: 0,
                    }, style: {
                        fontSize: calcFontSize,
                        fill: 'white',
                    }, center: { x: width / 2, y: 20 }, dy: 10, pointerWidth: 4 }), key: 'item' + idx, interpolation: "catmullRom", data: item, style: { data: ChartStyles_1.ChartStyles.data } }));
        })))), [props, xLabels, data, calcFontSize, width]);
}
exports.Area3DStacked = Area3DStacked;
exports.default = Area3DStacked;
